export const swiftCode = {
    249: 'FR',
    276: 'DE',
    20: 'AD',
    32: 'AR',
    40: 'AT',
    56: 'BE',
    100: 'BG',
    124: 'CA',
    156: 'CN',
    196: 'CY',
    191: 'HR',
    208: 'DK',
    724: 'ES',
    233: 'EE',
    840: 'US',
    246: 'FI',
    292: 'GI',
    300: 'GR',
    344: 'HK',
    348: 'HU',
    356: 'IN',
    372: 'IE',
    376: 'IL',
    380: 'IT',
    392: 'JP',
    832: 'JE',
    428: 'LV',
    438: 'LI',
    440: 'LT',
    442: 'LU',
    458: 'MY',
    470: 'MT',
    492: 'MC',
    578: 'NO',
    528: 'NL',
    616: 'PL',
    620: 'PT',
    203: 'CZ',
    642: 'RO',
    826: 'GB',
    702: 'SG',
    703: 'SK',
    705: 'SI',
    752: 'SE',
    756: 'CH',
    158: 'TW',
    764: 'TH',
    336: 'VA',
};
export const DomTomIsoCodes = [312, 328, 638, 474];
